import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { appConfig } from "./utils/config";

const langs = appConfig.languages.available;
const defaultLang = appConfig.languages.default;
const fallbackLang = appConfig.languages.fallback;

const resources = langs.reduce((acc, lang) => {
  try {
    acc[lang] = {
      translation: require(`./locales/${lang}.json`),
    };
  } catch (err) {
    console.warn(`Missing language file: ${lang}.json`);
  }
  return acc;
}, {});

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLang,
  fallbackLng: fallbackLang,
  interpolation: { escapeValue: false },
});

export default i18n;

export const availableLanguages = langs.map((code) => {
  const displayName = new Intl.DisplayNames([code], { type: "language" }).of(
    code
  );
  const label = displayName.charAt(0).toUpperCase() + displayName.slice(1);
  return { code, label };
});
